import { exists, createElement, toggleClass, onlyNumbers, moveToBody } from './helpers';

export class Modal {
    
  constructor(args) {
        const {
          modalSelector = null,
          openSelector = '[data-href]',
          closeSelector = '.close-modal',
          timeBefore = null,
          timeActive = null,
          activeClass = acseoPlugin.activeCssClass,
          createOverlay = false,
          moveToBody = false,
          openCallback = null,
          closeCallback = null
        } = args;

        if (!exists(modalSelector)) return;
        
        this.modalSelector = modalSelector;
        this.openSelector = openSelector;
        this.closeSelector = closeSelector;
        this.timeBefore = timeBefore;
        this.timeActive = timeActive;
        this.activeClass = activeClass;
        this.createOverlay = createOverlay;
        this.moveToBody = moveToBody;
        this.openCallback = openCallback;
        this.closeCallback = closeCallback;

        this.modal = null;
        this.opens;
        this.closes;
        this.overlay;

        if (!this.setModal()) return;
        this.setOpenButtons();
        this.setCloseButtons();
        this.setOverlay();
        this.modalTiming();

      }

  setModal() {
      let modal = document.querySelector(this.modalSelector);
      if(!exists(modal)) return false;
      this.modal = modal;
      if(this.moveToBody == true) moveToBody(this.modal);

      return true;
    }

  setOpenButtons() {
      let openButtons = document.querySelectorAll(this.openSelector);
      if(!exists(openButtons)) return;
      this.opens = openButtons;
      
      this.opens.forEach(open =>{
        open.addEventListener("click", function(e){
          e.preventDefault();
          this.toggleElements();
          this.runCallback(this.openCallback);
        }.bind(this));
      });
    }

  setCloseButtons() {
      let closeButtons = document.querySelectorAll(this.closeSelector);
      if(!exists(closeButtons)) return;
      this.closes = closeButtons;

      this.closes.forEach(close =>{
        close.addEventListener("click", function(e){
          e.preventDefault();
          this.toggleElements();
          this.runCallback(this.closeCallback);
        }.bind(this));
      });
    } 

  setOverlay() {
      if(this.createOverlay == false) return;

      this.overlay = createElement('div', false, 'modal-overlay');
      //if(this.moveToBody == true) moveToBody(this.overlay);
      this.modal.before(this.overlay);
      
      this.overlay.addEventListener("click", function(e){
        e.preventDefault();
        e.preventDefault();
          this.toggleElements();
          this.runCallback(this.closeCallback);
      }.bind(this));
    }
  
  modalTiming() {
      if(!this.timeBefore && !this.timeActive) return;

      let before = onlyNumbers(this.timeBefore);
      if (before || before === 0) {
        setTimeout(() => {
          this.modal.classList.add(this.activeClass);
        }, before);
      }

      let length = onlyNumbers(this.timeActive);
      if (length && length !== 0) {
        if (before) length += before;
        setTimeout(() => {
          this.modal.classList.remove(this.activeClass);
        }, length);
      }
    }

  toggleElements() {
      toggleClass(this.modal, this.activeClass);
      if(exists(this.overlay)) toggleClass(this.overlay, this.activeClass);
       
      this.opens.forEach(open => {
        toggleClass(open, this.activeClass);
      });

      this.closes.forEach(close => {
        toggleClass(close, this.activeClass);
      });

    }

  runCallback(callback) {
      if (typeof callback !== 'function') return;
      callback();
    }

  destroy() {
      this.modal = null;
      this.opens.forEach(open => {
        open.removeEventListener("click", this.setOpenButtons());
      });
      this.closes.forEach(close => {
        close.removeEventListener("click", this.setCloseButtons());
      });
      //this.overlay.removeEventListener("click", this.setOverlay());
      this.overlay.remove();
  }

}